const IMAGE = `
image {
  url
  url_m
  url_t
  url_img_fr
  url_m_fr
  url_t_fr
  url_img_es
  url_m_es
  url_t_es
  width_d
  width_t
  width_m
  height_d
  height_t
  height_m
  alt
  useTranslationText
  crop_d
  crop_t
  crop_m
}`;

const COLOR = `
color {
  color
}`;

const VIDEO = `
video {
  url
  url_t
  url_m
  url_fr
  url_m_fr
  url_t_fr
  url_es
  url_m_es
  url_t_es
  height_d
  height_t
  height_m
  title
  autoplay
  controls
  loop
  muted
  inline
  hls
  onscroll_animation
  popUpVideo
  poster_url
  poster_url_t
  poster_url_m
}`;

const BIRTHDAY_COMMON_SECTION = `
headerText {
  textItems {
    text
    style
    styledObj
    styledObjWeb
  }
  link {
    url
    title
    target
  }
}
linkedImage{
  ${IMAGE}
  ${COLOR}
  link {
    url
    text
    title
    target
  }
}
singleCTAButton {
  url
  text
  target
  title
  styledObj
  styledObjWeb
}
`;

const getBirthdayQuery = () =>
  `birthday {
  wrapped {
    ${BIRTHDAY_COMMON_SECTION}
  }
  revealed {
    ${BIRTHDAY_COMMON_SECTION}
  }
}`;

const query = ({ slot, contentId, lang }) => `
  ${slot}: moduleById(${
  lang && lang.length > 0 && lang !== 'en'
    ? `id: "${contentId}", lang: "${lang}"`
    : `id: "${contentId}"`
}) {
	contentId
	name
	type
  errorMessage
	set {
    val
    key
  }
  composites {
    ${getBirthdayQuery()}
    headerText {
      textItems {
        text
        style
        styledObj
        styledObjWeb
      }
      link {
        url
        title
        target
      }
    }
    linkedImage {
      ${IMAGE}
      ${COLOR}
      ${VIDEO}
      link {
        url
        text
        title
        target
      }
    }
    hplpLinkedImage {
      ${IMAGE}
      ${COLOR}
      ${VIDEO}
      link {
        url
        text
        title
        target
      }
    }
    prductCategory{
       key
       val
    }
    singleCTAButton {
      url
      text
      target
      title
      styledObj
      styledObjWeb
    }
  }
}
`;
module.exports = {
  buildQuery: query,
};
